// @ts-nocheck
import { isObject, path } from './obj'
import environment from './env'

interface Slice {
  value?: string
  valueFrom?: string
  validIf?: string
}

/**
 * Takes an object slice from the schema, and finds whether the slice is a 'value' or 'valueFrom'
 * type.
 *
 * @param {Object} slice
 * @param {*] [slice.value] - The absolute value.
 * @param {string} [slice.valueFrom] - The path to the value on the dataset.
 * @returns {[ValueType, Value]}
 */
const getValueType = (slice: Slice): [any, any] => {
  if (!isObject(slice)) {
    return [null, null]
  }

  if ({}.hasOwnProperty.call(slice, 'valueFrom')) {
    return ['valueFrom', slice.valueFrom]
  }

  if ({}.hasOwnProperty.call(slice, 'value')) {
    return ['value', slice.value]
  }

  return [null, null]
}

/**
 * Takes an object slice from the schema, along with the dataset, and returns the absolute value,
 * either from the dataset or the schema.
 *
 * @param {Object} slice
 * @param {*] [slice.value] - The absolute value.
 * @param {string} [slice.valueFrom] - The path to the value on the dataset.
 * @param {Object} dataset - The dataset to lookup.
 * @returns {Value}
 */
export const getValue = (slice: Slice, dataset: any) => {
  const [type, value] = getValueType(slice)
  if (type === 'valueFrom') {
    return getValueFromKey(value, dataset)
  }

  return value
}

export const formatGetValue = (value, data) => {
  const val = getValue(value, data)

  if (typeof val === 'boolean') {
    return val ? 'Yes' : 'No'
  }

  return val
}

export const getFirstValue = (slice, dataset) => {
  if (Array.isArray(slice)) {
    for (const s of slice) {
      const val = getValue(s, dataset)
      if (val) {
        return val
      }
    }
  } else {
    return getValue(slice, dataset)
  }
}

/**
 * Takes an key from the schema, along with the dataset, and returns the absolute value
 *
 * @param {*] [key] - The key to lookup value for.
 * @param {Object} dataset - The dataset to lookup.
 * @returns {Value}
 */
const getValueFromKey = (key: string, dataset: any) => {
  const valueFromData = path(key.split('.'), dataset)
  return Array.isArray(valueFromData) ? valueFromData[0] : valueFromData
}

export const getArrayValue = (slice: Slice, dataset: any) => {
  const [type, value] = getValueType(slice)
  if (type === 'valueFrom') {
    return path(value.split('.'), dataset)
  }

  return value
}

/**
 * Handles getting the href value and when not production it modifies it to be relative
 *
 * @param {Object} slice
 * @param {Object} dataset - The dataset to lookup.
 *
 */
export const getHrefValue = (slice: Slice, dataset: any) => {
  const value = getValue(slice, dataset)

  if (environment !== 'production' && value?.length) {
    try {
      const href = new URL(value)
      return `${href.pathname}${href.search}`
    } catch (e) {
      return value
    }
  }

  return value
}
